module.exports = __webpack_public_path__ + "img/3.304a5204.svg";